import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SectionHeading from "@/components/feature/SectionHeading";

const team = [
  {
    name: "沈一白",
    role: "主编 · 娱乐线",
    desc: "十年娱乐记者，擅长梳理事件时间线与多方回应。",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20calm%20professional%20asian%20editor%20in%20a%20warm%20beige%20studio%2C%20soft%20window%20light%2C%20minimal%20clean%20background%2C%20documentary%20photography%2C%20neutral%20tones&width=400&height=400&seq=team-editor-shen&orientation=squarish",
  },
  {
    name: "陈默",
    role: "深度组 · 产业调查",
    desc: "关注片酬结构、合约条款与制作成本，习惯从合同读故事。",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20thoughtful%20asian%20male%20journalist%20with%20glasses%20in%20a%20warm%20beige%20studio%2C%20soft%20directional%20light%2C%20minimal%20background%2C%20documentary%20photography&width=400&height=400&seq=team-editor-chen&orientation=squarish",
  },
  {
    name: "苏黎",
    role: "产业组 · 影视市场",
    desc: "长期跟踪票房、剧集与平台采购逻辑，写数据也写人。",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20confident%20young%20asian%20woman%20editor%20in%20a%20soft%20cream%20studio%2C%20natural%20light%2C%20minimal%20background%2C%20editorial%20photography%2C%20warm%20tones&width=400&height=400&seq=team-editor-su&orientation=squarish",
  },
  {
    name: "周未",
    role: "编辑 · 现场与路透",
    desc: "跑现场、核对原始素材，习惯先问「这条信息谁先说的」。",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20friendly%20asian%20field%20reporter%20with%20a%20canvas%20jacket%20in%20a%20warm%20neutral%20studio%2C%20soft%20light%2C%20minimal%20background%2C%20documentary%20photography&width=400&height=400&seq=team-editor-zhou&orientation=squarish",
  },
];

export default function AboutPage() {
  usePageMeta({
    title: "关于我们 - 黑料吃瓜",
    description:
      "了解黑料吃瓜的站点定位、内容范围与编辑准则。我们以时间线与多方回应还原娱乐事件，并明确区分事实与未经证实的讨论。",
    keywords: "关于黑料吃瓜,编辑团队,内容准则,版权声明,免责声明,娱乐资讯平台",
  });

  return (
    <div className="max-w-[1320px] mx-auto px-4 md:px-6 py-5 md:py-7">
      <Breadcrumb items={[{ label: "关于我们" }]} />

      <section className="mt-4 rounded-lg overflow-hidden relative">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20empty%20modern%20newsroom%20at%20night%20with%20rows%20of%20desks%2C%20glowing%20monitors%20and%20warm%20hanging%20lights%2C%20deep%20navy%20atmosphere%20with%20amber%20highlights%2C%20cinematic%20architectural%20photography%2C%20no%20people%2C%20no%20readable%20text&width=1600&height=600&seq=about-newsroom-hero&orientation=landscape"
            alt="黑料吃瓜编辑部夜间工作区"
            title="黑料吃瓜 - 编辑部工作区"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/92 via-primary-950/75 to-primary-950/40" />
        </div>
        <div className="relative px-5 md:px-10 py-10 md:py-14">
          <p className="text-[11.5px] tracking-[0.24em] text-accent-400 mb-3">ABOUT US</p>
          <h1 className="font-heading text-2xl md:text-[34px] font-black text-background-50 leading-snug max-w-2xl">
            我们只做一件事：把娱乐圈的事说清楚
          </h1>
          <p className="text-[13.5px] md:text-[15px] text-background-200 leading-8 mt-4 max-w-2xl">
            黑料吃瓜是一个以娱乐八卦、明星黑料与产业新闻为核心的内容平台。我们相信「吃瓜」不等于传谣：一条爆料能否成立，取决于它是否有可追溯的来源、清晰的时间线和当事方的回应。
          </p>
          <div className="flex flex-wrap gap-3 mt-6">
            <Link
              to="/gossip"
              className="inline-flex items-center gap-1.5 px-4 h-10 rounded-md bg-accent-500 text-primary-950 text-[13px] font-medium whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-newspaper-line" />
              浏览八卦频道
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-1.5 px-4 h-10 rounded-md border border-background-50/30 text-background-100 text-[13px] whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-megaphone-line" />
              投递爆料线索
            </Link>
          </div>
        </div>
      </section>

      <section className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
        {[
          {
            icon: "ri-focus-3-line",
            title: "站点定位",
            text: "面向关注娱乐圈动态的读者，提供八卦、黑料与产业新闻三类内容。既有快速热点，也有需要慢读的深度梳理。",
          },
          {
            icon: "ri-shield-check-line",
            title: "内容准则",
            text: "优先采用可交叉验证的信息；无法确认的部分明确标注「尚未证实」；不使用未授权的私人影像作为传播素材。",
          },
          {
            icon: "ri-time-line",
            title: "更新节奏",
            text: "热点事件 24 小时内跟进首轮核实结果；深度稿通常需要 3 至 7 天，用于核对合同、行程与多方回应。",
          },
        ].map((card) => (
          <div key={card.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
            <span className="w-10 h-10 rounded-md bg-accent-50 flex items-center justify-center">
              <i className={`${card.icon} text-xl text-accent-600`} />
            </span>
            <h2 className="font-heading text-base font-bold text-foreground-900 mt-3">{card.title}</h2>
            <p className="text-[13px] text-foreground-600 leading-7 mt-1.5">{card.text}</p>
          </div>
        ))}
      </section>

      <section className="mt-9 md:mt-12">
        <SectionHeading title="编辑团队" desc="内容由固定编辑团队署名，线索来源单独留存" accent="primary" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {team.map((member) => (
            <div key={member.name} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <div className="w-full h-44 bg-background-200">
                <img
                  src={member.avatar}
                  alt={`${member.name} - 黑料吃瓜编辑`}
                  title={`${member.name} - ${member.role}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading text-[15px] font-bold text-foreground-900">{member.name}</h3>
                <p className="text-[11.5px] text-accent-700 mt-0.5">{member.role}</p>
                <p className="text-[12.5px] text-foreground-500 leading-6 mt-2">{member.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-9 md:mt-12 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] gap-6">
        <div className="space-y-5">
          <div id="copyright" className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 scroll-mt-28">
            <h2 className="font-heading text-lg font-bold text-foreground-900 flex items-center gap-2">
              <i className="ri-copyright-line text-primary-600" />
              版权声明
            </h2>
            <p className="text-[13.5px] text-foreground-600 leading-7 mt-2.5">
              站内文字内容、栏目编排与页面设计归本网站所有，未经授权不得整体转载或用于商业用途。引用单篇内容时，请保留作者署名与原文链接。
            </p>
            <p className="text-[13.5px] text-foreground-600 leading-7 mt-2">
              站内图片均为场景示意图。当前版本为产品演示，所有人物、事件与机构均为虚构，不对应任何真实对象。
            </p>
          </div>

          <div id="disclaimer" className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 scroll-mt-28">
            <h2 className="font-heading text-lg font-bold text-foreground-900 flex items-center gap-2">
              <i className="ri-alert-line text-accent-600" />
              免责声明
            </h2>
            <p className="text-[13.5px] text-foreground-600 leading-7 mt-2.5">
              本平台内容仅作资讯交流之用，不构成对任何个人或机构的评价。对于标注为「传闻」「讨论中」的内容，本平台不对其真实性作出保证。
            </p>
            <p className="text-[13.5px] text-foreground-600 leading-7 mt-2">
              若权利人认为内容存在侵权或不实，可通过联系页面提交说明与证明材料，我们会在核实后 48 小时内处理。
            </p>
          </div>
        </div>

        <aside className="space-y-5">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h2 className="font-heading text-base font-bold text-foreground-900">联系方式</h2>
            <ul className="mt-3 space-y-3 text-[13px] text-foreground-600">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line text-primary-600 mt-0.5" />
                <span>
                  内容合作
                  <span className="block text-foreground-500 text-[12.5px]">editor@heiliao-demo.site</span>
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-megaphone-line text-primary-600 mt-0.5" />
                <span>
                  线索投递
                  <span className="block text-foreground-500 text-[12.5px]">使用联系页表单，可匿名单项填写</span>
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-primary-600 mt-0.5" />
                <span>
                  办公地址
                  <span className="block text-foreground-500 text-[12.5px]">演示站点 · 地址信息暂未公开</span>
                </span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-4 inline-flex items-center gap-1.5 px-4 h-9 rounded-md bg-primary-500 text-background-50 text-[12.5px] whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-chat-3-line" />
              前往联系反馈
            </Link>
          </div>

          <div className="rounded-lg bg-accent-50 border border-accent-200 p-5">
            <h2 className="font-heading text-base font-bold text-primary-900">一条线索的诞生</h2>
            <ol className="mt-3 space-y-2.5 text-[12.5px] text-foreground-700 leading-6">
              {["收到投递并登记来源", "交叉核对公开行程与文件", "向当事方发出置评请求", "发布并更新后续回应"].map(
                (step, index) => (
                  <li key={step} className="flex items-start gap-2">
                    <span className="w-5 h-5 shrink-0 rounded-full bg-accent-500 text-primary-950 text-[11px] font-bold flex items-center justify-center mt-0.5">
                      {index + 1}
                    </span>
                    {step}
                  </li>
                ),
              )}
            </ol>
          </div>
        </aside>
      </section>
    </div>
  );
}